import { OnInit, OnDestroy, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { CourtCase } from './court-case';
import { EventService } from './../shared/event.service';
import { CartService } from './../cart/cart.service';
import { PrintService } from './../print/print.service';

@Component({
  template: ''
})
export class BasePrintEmailComponent implements OnDestroy, OnInit {

  public currentStep: number;
  protected cases: CourtCase[];

  public pdfUri: string;
  public errors: string[] = [];
  public requestSubscription: Subscription;

  constructor(public eventService: EventService,
              public cartService: CartService,
              public printService: PrintService,
              public formBuilder: FormBuilder,
              private bsModalRef: BsModalRef,
              protected modalService: BsModalService
              ) {}

  ngOnInit() {
  }

  hideModal(): void {
    this.bsModalRef.hide();
  }

    getCases(): any[] { // TODO: data type
        return this.cases;
    }

    generatePdf(): Observable<string> { // Used by both email preview pdf and print confirm.

      this.errors = [];
      const response = this.printService.requestPdf(this.cases);
      this.requestSubscription = response
        .subscribe(
            (pdfUri: string) => {
                this.pdfUri = pdfUri;
            },
            (errorMessage: string) => {
                this.errors.push(errorMessage);
            }
        );
        return response;
    }

    goToStep(stepNumber: number): void {
      if (stepNumber < this.currentStep) {
        this.currentStep = stepNumber;
      }
    }

    continue(): void {
      this.hideModal();
    }

    clearHistory(): void {
      this.eventService.openClearHistory();
    }

    private cancelAnyOutstandingRequest() {
        if (this.requestSubscription) {
        this.requestSubscription.unsubscribe();
        }
    }

    isHttpRequestInProgress(): boolean {
      return this.requestSubscription &&
            !this.requestSubscription.closed;
    }

    ngOnDestroy() {
      this.cancelAnyOutstandingRequest();
    };

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/base-print-email.component.ts